import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import './global-components'
import { init as initVuex } from './store'
import i18n from './i18n'
import Vuelidate from 'vuelidate'
import PortalVue from 'portal-vue'
import Swal from 'sweetalert2'
Vue.use(PortalVue)
Vue.use(Vuelidate)

Vue.config.productionTip = false

/**
 * init the store instance
 * @return {Vuex.Store} The newly created vuex store
 */
const initStore = () => {
  Vue.use(Vuex);
  return initVuex()
};


/**
 * Protect routing
 */
router.beforeResolve((to, from, next) => {
  const isAuthenticated = () => !!localStorage.getItem('user');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (to.name === 'Login' && isAuthenticated()) next({name: 'Profile.account'})
  if (!requiresAuth) next()
  if (!isAuthenticated() && requiresAuth) next({name: 'Login'})
  next()
});

router.afterEach((to, from) => {
  Swal.close()
});


new Vue({
  router,
  store: initStore(),
  i18n,
  render: h => h(App),
  created() {
    Swal.close()
  }
}).$mount('#app')
